module.exports = __webpack_public_path__ + "static/media/woman-texting.475f555e.png";